module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/recurring-rc-474ebc7a42dab926e5f53f1dcb178c68.svg";